// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p3-1";
export var messageSideRight = "_p3-2";
export var orderLookupBubbleContainer = "_p3-0";
export var submitButton = "_p3-3";